import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import './Modals.css';
import './FootnotesModal.css';

const ScoreMethodologyModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    
    const handleClickOutside = (event) => {
      if (event.target.classList.contains('modal-overlay')) {
        onClose();
      }
    };
    
    const handleEscape = (event) => {
      if (event.key !== 'Escape') return;
      onClose();
      setTimeout(() => document.activeElement?.blur(), 0);
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className="modal-overlay">
      <div className="footnotes-modal">
        <div className="modal-header">
          <h2>KRIME Score&trade; Methodology</h2>
          <button className="close-button" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="modal-content">
          <div className="footnotes-list">
            <div className="footnote-item">
              <span className="footnote-asterisk">*</span>
              <span className="footnote-text">
                Composite KRIME Scores&trade; are calculated from weighted individual crimes only (Murder, Rape, Robbery, Aggravated Assault, Burglary, Larceny/Theft, Motor Vehicle Theft). Aggregate weights represent the sum of individual crime weights within each category (All Crime, Violent Crime, Property Crime).
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ScoreMethodologyModal;